import { Box, TextField, Button, Select, MenuItem, Table, TableBody, TableRow, TableCell, TableContainer, TableHead, FormControl, Stack, Pagination, FormControlLabel, Checkbox, ListItemText } from '@mui/material'
import React, { useEffect, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from 'components/Loader';
import * as api from '../services/api'
import ModalHistoryProjectParticipation from 'components/modal/healthPromotion/ModalHistoryProjectParticipation';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'; // default icon


function ParticipantScreening() {
    const location = useLocation()
    const navigate = useNavigate()
    const auth = useSelector((state) => state.auth.user_data)
    const [loading, setLoading] = useState(false)

    const [search, setSearch] = useState('')
    const [year, setYear] = useState(location.state.year)
    const [department, setDepartment] = useState(auth.permission.group_code == 'G-17' ? auth.department.department_code : '')
    const [optionDepartment, setOptionDepartment] = useState([])

    const [healthcheck, setHealthcheck] = useState('null')
    const [optionHealthCheck, setOptionHealthCheck] = useState([])

    const [riskgroup, setRiskgroup] = useState([])
    const [optionRiskgroup, setOptionRiskgroup] = useState([])

    const [page, setPage] = useState(1)
    const [maxPage, setMaxPage] = useState(1)
    const [showList, setShowList] = useState([])

    const [selected, setSelected] = useState([]); //pid
    const [selectedData, setSelectedData] = useState([]); //item
    const [selectAll, setSelectAll] = useState(false);

    const [itemHistory, setItemHistory] = useState([])
    const [openModalHistory, setOpenModalHistory] = useState(false)

    const [projectName, setProjectName] = useState(location.state.name)
    const [projectCode, setProjectCode] = useState(location.state.code)

    const [headerKey, setHeaderKey] = useState([])

    useEffect(() => {
        findDepartment()
    }, [])

    useEffect(() => {
        patientList()
    }, [page, department, riskgroup])

    useEffect(() => {
        setPage(1)
    }, [department, riskgroup, search])

    // useEffect(() => {
    //     console.log(selected);
    // }, [selected]);
    // useEffect(() => {
    //     console.log(selectedData);
    // }, [selectedData]);

    const handlePageChange = (event, page) => {
        setPage(page)
        setSelectAll(false)
    }

    const findDepartment = async () => {
        setLoading(true)
        let res = await api.findDepartmentFixToken()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                let data = res['data']['data']

                let option = []
                data.forEach((item) => {
                    const code = item?.department_code;
                    const name = item?.department_name;
                    if (code && name) {
                        option.push({ key: code, value: name });
                    }
                });

                const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                setOptionDepartment(unique)
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const getValueAndResultKeys = (dataArray, text) => {
        if (text === 'headetTable') {
            const keySet = new Set();
            dataArray.forEach(obj => {
                Object.keys(obj).forEach(key => {
                    if (key.includes('value_') || key.includes('result_')) {
                        keySet.add(key);
                    }
                });
            });
            return Array.from(keySet);
        } else {
            const keySet = new Set();
            dataArray.forEach(obj => {
                Object.keys(obj).forEach(key => {
                    if (key.includes('result_')) {
                        keySet.add(key);
                    }
                });
            });
            return Array.from(keySet);
        }

    };

    const patientList = async () => {
        setLoading(true)
        let res = await api.patientList(year, projectCode, page, department === 'null' ? '' : department, search, riskgroup.length == 0 ? null : healthcheck, riskgroup.length == 0 ? null : riskgroup)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                let data = res['data']['data']
                setShowList(data);

                const showPid = data.map(item => item.pid);
                setSelectAll(showPid.every(pid => selected.includes(pid)))

                const filteredKey = getValueAndResultKeys(data, 'headetTable');
                setHeaderKey(filteredKey)
                // console.log(filteredKey)

                const filterOption = getValueAndResultKeys(data)
                setOptionHealthCheck(filterOption)

                let pagg = res['data']['pagging']
                setPage(pagg['page'])
                setMaxPage(pagg['totalPage'])
            } else if (res['data']['code'] === 999) {
                console.log(res['data']['message'])
                setShowList([])
                setPage(1)
                setMaxPage(1)
                setHeaderKey([])
            } else {
                setShowList([])
                setPage(1)
                setMaxPage(1)
                setHeaderKey([])

                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            let newSelected = [...selected];
            const selectedList = showList.filter(item => !newSelected.includes(item.pid));
            newSelected = newSelected.concat(selectedList.map(item => item.pid));

            let newSelectedData = [...selectedData, ...selectedList];

            setSelectedData(newSelectedData);
            setSelected(newSelected);
            setSelectAll(true);
        } else {
            let newSelected = [...selected];
            const newShowList = showList.map(item => item.pid);
            newSelected = newSelected.filter(pid => !newShowList.includes(pid));

            let newSelectedData = [...selectedData];
            newSelectedData = newSelectedData.filter(item => newSelected.includes(item.pid));

            setSelectedData(newSelectedData);
            setSelected(newSelected);
            setSelectAll(false);
        }
    };
    const handleChange = (event, i) => {
        if (selected.includes(i.pid)) {
            setSelected(selected.filter(item => item !== i.pid));
            setSelectedData([...selectedData].filter(item => item.pid !== i.pid));
        } else {
            setSelected([...selected, i.pid]);
            let newSelectedData = [...selectedData, i];
            setSelectedData(newSelectedData);
        }
    };

    const handleClickOpenHistory = (detail) => {
        setItemHistory(detail)
        setOpenModalHistory(true)
    }

    const handleClickSearch = () => {
        patientList()
    }

    const handleChangeOptionFilter = (value) => {
        setHealthcheck(value)
        switch (value) {
            case "NCDs":
                setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'เป็นโรค'])
                break;
            case "result_bmi": //ฺBMI
                setOptionRiskgroup(['น้ำหนักต่ำกว่าเกณฑ์', 'สมส่วน', 'น้ำหนักเกิน', 'โรคอ้วน', 'โรคอ้วนอันตราย'])
                break;
            case "ความดันโลหิต":
                setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ', 'พบแพทย์ด่วน', 'ต่ำกว่าเกณฑ์'])
                break;
            case "result_fbs": //น้ำตาลในเลือด
                setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ', 'พบแพทย์ด่วน'])
                break;
            case "Total Cholesterol":
                setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ'])
                break;
            case "Triglyceride":
                setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ', 'พบแพทย์ด่วน'])
                break;
            case "LDL":
                setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ', 'พบแพทย์ด่วน'])
                break;
            case "HDL":
                setOptionRiskgroup(['ต่ำ', 'สูง'])
                break;
            case "การตรวจตับ":
                setOptionRiskgroup(['ปกติ', 'ผิดปกติ', 'พบแพทย์ด่วน'])
                break;
            case "การตรวจไต":
                setOptionRiskgroup(['ปกติ', 'ผิดปกติ'])
                break;
            case "การตรวจ X-RAY":
                setOptionRiskgroup(['ปกติ', 'ผิดปกติ'])
                break;
            default:
                console.log("default");
        }
    }

    return (
        <>
            <Loader loading={loading} />
            {openModalHistory ?
                <ModalHistoryProjectParticipation
                    data={itemHistory}
                    onClose={() => { setOpenModalHistory(false) }}
                />
                : null
            }

            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/managePromote') }}
                    >กลับไป จัดการงานสร้างเสริม</Box>
                </Box>

                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}> {projectName} (คัดกรองรายชื่อเข้าร่วมโครงการ)</Box>

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'grid',
                    gridGap: '10px'
                }}>
                    <Box sx={{
                        fontWeight: 600,
                        "@media (max-width: 800px)": {
                            textAlign: "center",
                        },
                    }}>ค้นหาด้วยชื่อ</Box>
                    <Box sx={{
                        border: '1px solid #478F96',
                        borderRadius: '10px',
                        display: 'flex',
                        padding: '5px'
                    }}>
                        <TextField
                            fullWidth
                            variant="standard"
                            sx={{
                                ...InputCSS
                            }}
                            InputProps={{
                                disableUnderline: true,
                            }}
                            placeholder="พิมพ์ข้อความเพื่อค้นหาข้อมูล..."
                            value={search}
                            onChange={(e) => { setSearch(e.target.value) }}
                        />
                        <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        gridGap: '20px',
                        "@media (max-width: 800px)": {
                            display: 'grid',
                        },
                    }}>
                        <Box>
                            <Box sx={{ fontWeight: 500 }}>เลือกสังกัด</Box>
                            <Select
                                size="small"
                                sx={{ ...SelectCss, maxWidth: '200px' }}
                                value={department || 'null'}
                                onChange={(e) => { setDepartment(e.target.value) }}
                                slotProps={{
                                    input: {
                                        readOnly: auth.permission.group_code == 'G-17' && true,
                                    }
                                }}
                                IconComponent={
                                    auth.permission.group_code === 'G-17'
                                        ? () => null // ซ่อนไอคอน
                                        : KeyboardArrowDownIcon // แสดงปกติ
                                }
                            >
                                <MenuItem value="null">ทั้งหมด</MenuItem>
                                {optionDepartment.map((i, idx) => (
                                    <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
                                ))}
                            </Select>
                        </Box>
                        <hr color='#B0B0B0' />
                        <Box sx={{
                            display: 'flex',
                            gridGap: '10px'
                        }}>
                            <Box>
                                <Box sx={{ fontWeight: 500 }}>เลือกค่าที่ตรวจ</Box>
                                <Select
                                    size="small"
                                    sx={{ ...SelectCss }}
                                    value={healthcheck || 'null'}
                                    onChange={(e) => {
                                        handleChangeOptionFilter(e.target.value)
                                    }}
                                >
                                    <MenuItem value="null">ทั้งหมด</MenuItem>
                                    {optionHealthCheck.map((i, idx) => (
                                        <MenuItem key={idx} value={i}>{i}</MenuItem>
                                    ))}
                                </Select>
                            </Box>
                            <Box>
                                <Box sx={{ fontWeight: 500 }}>เลือกกลุ่มเสี่ยง</Box>
                                <Select
                                    disabled={healthcheck === 'null' ? true : false}
                                    size="small"
                                    fullWidth
                                    sx={{ ...SelectCss }}
                                    multiple
                                    value={riskgroup || ''}
                                    onChange={(e) => { setRiskgroup(e.target.value) }}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    <MenuItem value={''} disabled>เลือกกลุ่มเสี่ยง</MenuItem>
                                    {optionRiskgroup.map((i, idx) => (
                                        <MenuItem key={idx} value={i}>
                                            <Checkbox checked={riskgroup.indexOf(i) > -1} />
                                            <ListItemText primary={i} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{
                        overflow: 'auto'
                    }} >
                        <TableContainer sx={{ maxHeight: '700px' }} >
                            <Table sx={{ minWidth: '1500px' }}>
                                <TableHead sx={{ backgroundColor: '#C8EBEB' }}>
                                    <TableRow>
                                        <TableCell>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={selectAll === true}
                                                        onChange={handleSelectAll}
                                                    />
                                                }
                                                label="ทั้งหมด"
                                            />
                                        </TableCell>
                                        <TableCell>ปี</TableCell>
                                        <TableCell>ยศ</TableCell>
                                        <TableCell>ชื่อ-นามสกุล</TableCell>
                                        <TableCell width={'150px'}>เลขบัตรประชาชน</TableCell>
                                        <TableCell>อายุ</TableCell>
                                        <TableCell>สังกัด</TableCell>
                                        <TableCell minWidth={'120px'} align='center' >ประวัติการ เข้าร่วมโครงการ</TableCell>
                                        {headerKey.map((key, idx) => (
                                            <TableCell key={idx}>{key}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {showList.length > 0 ? (
                                        showList.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <FormControlLabel
                                                        key={item}
                                                        control={
                                                            <Checkbox
                                                                value={item}
                                                                checked={selected.includes(item.pid)}
                                                                onChange={(e) => { handleChange(e, item) }}
                                                            />
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell>{item['year_1']}</TableCell>
                                                <TableCell>{item['pname']}</TableCell>
                                                <TableCell>{item['fname'] + ' ' + item['lname']}</TableCell>
                                                <TableCell>{item['pid']}</TableCell>
                                                <TableCell>{item['age']}</TableCell>
                                                <TableCell>{item['department_name_short']}</TableCell>
                                                <TableCell align='center'>{item['join_project_history'] == true ?
                                                    <Box sx={{
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer'
                                                    }}
                                                        onClick={() => { handleClickOpenHistory(item['join_project_details']) }}
                                                    >มีประวัติ</Box>
                                                    : '-'}
                                                </TableCell>

                                                {headerKey.map((key, idx) => (
                                                    <TableCell key={idx}>{item[key] && item[key].trim() !== '' ? item[key] : '-'}</TableCell>
                                                ))}

                                            </TableRow>
                                        ))
                                    )
                                        :
                                        (
                                            <TableRow>
                                                <TableCell colSpan='8'>
                                                    <Box sx={{ textAlign: 'center' }}>ไม่มีข้อมูล</Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'end',
                        margin: 2
                    }}>
                        <Stack spacing={2}>
                            <Pagination
                                count={maxPage}
                                page={page}
                                onChange={handlePageChange}
                                shape="rounded"
                                color="primary"
                            />
                        </Stack>
                    </Box>

                    <Box>
                        <MyButton
                            number={selected.length}
                            onClick={() => { navigate('/selectedLists', { state: { name: projectName, code: projectCode, year: year, list: selectedData, pid: selected } }) }}
                        />
                    </Box>

                </Box>

            </Box >
        </>
    )
}

export default ParticipantScreening

const InputCSS = {
    padding: '5px',
    border: 'none',
    '&.MuiInputBase-root': {
        border: 'none'
    },
    '&.MuiInputBase-root:focus': {

    }
}

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        // borderColor: '#C8EBEB',
        border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
}

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -10,
        top: -10,
        border: `1px solid #E06262`,
        borderRadius: '5px',
        backgroundColor: '#E06262',
        padding: '0 4px',
        color: '#FFFFFF'
    },
}));

export const MyButton = ({ number, onClick }) => {
    return (
        <Button
            variant="contained"
            sx={{
                backgroundColor: 'primary.main',
                color: 'white',
                '&:hover': {
                    backgroundColor: 'primary.dark',
                },
            }}
            onClick={() => { onClick() }}
        >
            <StyledBadge badgeContent={number} color="secondary">
                รายชื่อที่เลือกไว้
            </StyledBadge>
        </Button>
    );
};
